<template>
  <div>
    <!-- 收款列表弹框 -->
    <el-dialog
      title="收款列表"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
      @close="handleClose">

      <div v-loading="loading">
        <el-table :data="incomeList" border>
          <el-table-column prop="name" label="收款名称" align="center" min-width="150"></el-table-column>
          <el-table-column prop="income_type" label="回款性质" align="center" width="100"></el-table-column>
          <el-table-column prop="income_amount" label="回款金额" align="center" width="120">
            <template slot-scope="scope">
              <span style="color: #67c23a; font-weight: bold;">
                {{ formatAmount(scope.row.income_amount) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="income_time" label="回款日期" align="center" width="120">
            <template slot-scope="scope">
              {{ formatDate(scope.row.income_time) }}
            </template>
          </el-table-column>
          <el-table-column label="审核状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.income_check_status > 0 ? 'success' : 'warning'">
                {{ scope.row.income_check_status > 0 ? '已审核' : '未审核' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.remarks || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="viewIncomeDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="!incomeList || incomeList.length === 0" style="text-align: center; padding: 40px; color: #999;">
          暂无收款记录
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 收款详情弹框 -->
    <el-dialog
      title="收款详情"
      :visible.sync="detailVisible"
      width="700px"
      :close-on-click-modal="false">

      <div v-loading="detailLoading">
        <el-descriptions :column="2" border v-if="incomeDetail">
          <el-descriptions-item label="回款性质">
            <el-tag :type="getIncomeTypeColor(incomeDetail.income_type)">
              {{ incomeDetail.income_type || '-' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="回款金额">
            <span style="color: #67c23a; font-weight: bold; font-size: 16px;">
              {{ formatAmount(incomeDetail.amount) }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="回款日期">
            {{ formatDate(incomeDetail.income_time) }}
          </el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="incomeDetail.income_check_status > 0 ? 'success' : 'warning'">
              {{ incomeDetail.income_check_status > 0 ? '已审核' : '未审核' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="发票类型" :span="2">
            {{ incomeDetail.invoice_type || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="发票号码" :span="2">
            {{ incomeDetail.ticket_no || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="客户名称" :span="2">
            {{ incomeDetail.party_a || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="项目名称" :span="2">
            {{ incomeDetail.project_name || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="业务类型" :span="2">
            {{ incomeDetail.entry_type_name || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="应收月份" :span="2">
            {{ incomeDetail.month || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="合同金额" :span="2">
            {{ formatAmount(incomeDetail.contract_amount) }}
          </el-descriptions-item>
          <el-descriptions-item label="开票金额" :span="2">
            {{ formatAmount(incomeDetail.invoiced_amount) }}
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">
            {{ incomeDetail.remarks || '-' }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- 附件展示 -->
        <div v-if="incomeDetail && incomeDetail.files" style="margin-top: 20px;">
          <div style="font-weight: bold; margin-bottom: 10px;">附件：</div>
          <div v-for="(file, index) in parseFiles(incomeDetail.files)" :key="index" style="margin-bottom: 8px;">
            <el-link
              type="primary"
              :href="file.url"
              target="_blank"
              :underline="false">
              <i class="el-icon-document"></i> {{ file.name }}
            </el-link>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";
import Api from "../common/Api";

export default {
  name: "IncomeDetailDialog",
  data() {
    return {
      dialogVisible: false,
      detailVisible: false,
      loading: false,
      detailLoading: false,
      financeId: null,
      incomeList: [],
      incomeDetail: null
    };
  },
  methods: {
    // 打开弹框
    open(financeId) {
      this.financeId = financeId;
      this.dialogVisible = true;
      this.loadIncomeList();
    },

    // 加载收款列表
    loadIncomeList() {
      if (!this.financeId) {
        this.$message.warning('费项ID不能为空');
        return;
      }

      this.loading = true;
      Api.incomeList(
        { finance_id: this.financeId },
        1,
        100,
        (res) => {
          this.incomeList = res.list || [];
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },

    // 查看收款详情
    viewIncomeDetail(row) {
      this.detailLoading = true;
      this.detailVisible = true;

      // 获取收款详细信息
      CommonHelp.get("FinanceIncome/getDetail", { id: row.income_id || row.id }, res => {
        this.detailLoading = false;
        if (res.code === 1) {
          this.incomeDetail = res.data;
        } else {
          this.$message.error(res.msg || '获取收款详情失败');
        }
      });
    },

    // 关闭弹框
    handleClose() {
      this.incomeList = [];
      this.incomeDetail = null;
      this.financeId = null;
    },

    // 格式化金额
    formatAmount(amount) {
      if (!amount && amount !== 0) return '-';
      return parseFloat(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-';

      // 如果是字符串，尝试解析
      if (typeof timestamp === 'string') {
        // 如果已经是格式化的日期字符串，直接返回
        if (timestamp.includes('-') || timestamp.includes('/')) {
          return timestamp;
        }
        // 尝试转换为数字
        timestamp = parseInt(timestamp);
      }

      // 如果是数字，判断是秒级还是毫秒级时间戳
      if (typeof timestamp === 'number') {
        // 如果时间戳小于 10000000000，说明是秒级，需要转换为毫秒级
        if (timestamp < 10000000000) {
          timestamp = timestamp * 1000;
        }

        // 使用 JavaScript Date 对象格式化
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }

      return '-';
    },

    // 获取回款性质标签颜色
    getIncomeTypeColor(type) {
      if (!type) return 'info';
      if (type === '当期') return 'success';
      if (type === '历史') return 'warning';
      return 'info';
    },

    // 解析附件
    parseFiles(filesStr) {
      if (!filesStr) return [];
      try {
        const files = typeof filesStr === 'string' ? JSON.parse(filesStr) : filesStr;
        return Array.isArray(files) ? files.map(file => ({
          name: file.name || file.file_name || '附件',
          url: file.path || file.file_path || file.url || ''
        })) : [];
      } catch (e) {
        console.error('解析附件失败:', e);
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-descriptions-item__label {
  font-weight: bold;
  background-color: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/IncomeDetailDialog.vue